<template>
  <view class="image-list" wx:if="{{show}}">
    <image
      wx:for="{{list}}"
      class="image"
      wx:key="image"
      src="{{item.image}}"
      wx:style="{{item.style}}"
      mode="widthFix"
      webp
    />
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { getStyle } from '../../../src/lib/editor/BaseForm'
createComponent({
  properties: {
    imageList: Array,
    isAsync: {
      type: Boolean,
      value: true,
    },
  },
  data: {
    show: false,
    list: [],
  },
  watch: {
    imageList: {
      handler() {
        this.isAsync ? setTimeout(() => {
          this.show = true
        }, 500) : (this.show = true)
        this.list = this.imageList.map(item => {
          return {
            ...item,
            style: getStyle(item.style),
          }
        })
      },
      immediate: true,
    },
  },
})
</script>

<style lang="stylus" scoped>
  .image-list
    text-align center
</style>

<script type="application/json" lang="json">
{
  "component": true
}
</script>
